import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('idx_user_calendar_token_token', ['token'], { unique: true })
@Index('idx_user_calendar_token_user', ['fkUserId'])
@Entity('user_calendar_token')
export class UserCalendarTokenEntity extends BaseEntity {
	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: '_token', length: 64, unique: true })
	public token!: string;

	@Column('tinyint', {
		name: '_isActive',
		width: 1,
		default: () => "'1'",
	})
	public isActive!: boolean;

	@Column('datetime', { name: '_lastUsed', nullable: true })
	public lastUsed!: Date | null;

	@ManyToOne(() => UserEntity, { onDelete: 'CASCADE', onUpdate: 'CASCADE' })
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
